import React, { useContext, useEffect } from 'react';
import './menu.css';
import RestaurentContext from '../../../../context/rest_context';
import { AiFillCloseCircle } from "react-icons/ai"

const MenuModal = ({ closeModal }) => {
  const { restCat, restItems } = useContext(RestaurentContext);
  const menuMap = new Map();

  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "scroll";
    }
  }, [])

  restCat.forEach((cat, _) => {
    const items = restItems.filter(item => item.menuId === cat.dbID);
    if (items.length !== 0) {
      menuMap.set(cat.name, items.length);
    }
  });

  console.log(menuMap);

  const scrollToFoodItemCategory = (categoryName) => {
    const categoryElement = document.getElementById(`category-${categoryName}`);
    console.log(categoryElement)
    if (categoryElement) {
      categoryElement.scrollIntoView({ behavior: 'smooth' });
    }
  };


  return (
    <div className='modal-wrapper' >
      {
        <div className='menu-modal-container' >
          <div className='menu-bar-container'>
            <h4>Menu</h4>
            <span onClick={closeModal} > <AiFillCloseCircle /></span>
          </div>
          <div className='menu-item-container' >
            {[...menuMap].map(([key, value]) => (
              <div onClick={() => {
                scrollToFoodItemCategory(key);
                closeModal()
              }
              } className='menu-item' key={key}>
                <p>{key}</p>
                {/* <span>{value}</span> */}
              </div>
            ))}
          </div>
        </div>
      }
    </div>
  );
};

export default MenuModal;
